import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Button } from 'ui/component/Button.tsx';
import { ILocked } from 'ui/component/Icons.tsx';

// Full-area "no access" state shown inside a page content area when the user lacks permission
// (e.g. an operator whose temporary support access was revoked).
export const Forbidden = () => {
  const { t } = useTranslation();

  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center gap-5 px-6 text-center">
      <div aria-hidden="true" className="flex h-16 w-16 items-center justify-center rounded-full bg-white shadow-sm">
        <ILocked size={30} className="text-blue" />
      </div>
      <div className="flex max-w-md flex-col gap-2">
        <h2 className="font-semibold text-xl">{t('errors.forbiddenTitle')}</h2>
        <p className="text-gray-500 text-sm">{t('errors.forbidden')}</p>
      </div>
      <Link to="/">
        <Button className="blue w-max">{t('actions.goToHomepage')}</Button>
      </Link>
    </div>
  );
};
